import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Icon from 'components/Icon'
import theme from 'theme'
import TrackedExternalLink from 'components/common/TrackedExternalLink'
import TextButton from 'components/common/TextButton'

const NavLink = ({
  to,
  disabled,
  href,
  active,
  enabled = true,
  icon,
  text,
  showNotification,
  ...rest
}) => {
  if (!enabled) return null

  const Component = to ? Link : href ? TrackedExternalLink : TextButton

  if (disabled) {
    rest.onClick = e => e.preventDefault()
  }

  return (
    <Component
      css={[
        {
          cursor: disabled ? 'not-allowed' : 'pointer',
          textAlign: 'center',
          fontSize: theme.fontSizes[0],
          fontWeight: theme.fontWeights[1],
          color: disabled ? theme.colors.steel[1] : theme.colors.steel[0],
          display: 'block',
          width: '100%',
          paddingTop: theme.space[3],
          paddingBottom: theme.space[3],
          paddingLeft: theme.space[1],
          paddingRight: theme.space[1],

          '&:hover, &:focus': {
            color: disabled ? theme.colors.steel[1] : theme.colors.white[0]
          }
        },

        showNotification && {
          position: 'relative',
          '&::before': {
            content: "''",
            position: 'absolute',
            top: theme.space[2],
            right: theme.space[3],
            width: theme.space[2],
            height: theme.space[2],
            borderRadius: theme.borderRadius[2],
            background: theme.colors.yellow[0],
            border: `2px solid ${theme.colors.steel[2]}`,
            zIndex: 2
          }
        },

        active && {
          color: theme.colors.white[0],
          background: theme.colors.black[0],

          '&:hover, &:focus': {
            color: theme.colors.white[0],
            cursor: 'default'
          }
        }
      ]}
      href={href}
      to={to}
      {...rest}
    >
      <Icon
        css={[
          {
            width: theme.fontSizes[4],
            height: theme.fontSizes[4],
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: theme.space[1]
          }
        ]}
        data-test-navigation-notification={showNotification}
        icon={icon}
      />
      {text}
    </Component>
  )
}

NavLink.propTypes = {
  href: PropTypes.string,
  disabled: PropTypes.bool,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  active: PropTypes.bool,
  enabled: PropTypes.bool,
  icon: PropTypes.string,
  text: PropTypes.string,
  showNotification: PropTypes.bool
}

export default NavLink
